<div class="page-login">
  <h1 class="page-login__title">
    {{ appName }}
  </h1>

  <div class="page-login__auth-caption" [ngClass]="'auth-caption--' + selectedAuthType().toLowerCase()">
    <i
      nz-icon
      class="page-login__auth-icon"
      [ngClass]="'auth-icon--' + selectedAuthType().toLowerCase()"
      [nzType]="
        selectedAuthType() === AuthType.BASIC ? 'user' : selectedAuthType() === AuthType.STUDENT ? 'idcard' : 'solution'
      "
      nzTheme="outline">
    </i>

    <span class="page-login__auth-caption-text" [ngClass]="'auth-caption-text--' + selectedAuthType().toLowerCase()">
      @switch (selectedAuthType()) {
        @case (AuthType.BASIC) {
          Базовая аутентификация
        }
        @case (AuthType.STUDENT) {
          Аутентификация обучающегося
        }
        @case (AuthType.LECTURER) {
          Аутентификация преподавателя
        }
      }
    </span>
  </div>

  <div class="page-login__form-wrapper" [ngClass]="'auth-type--' + selectedAuthType().toLowerCase()">
    @switch (selectedAuthType()) {
      @case (AuthType.BASIC) {
        <app-basic-auth></app-basic-auth>
      }
      @case (AuthType.STUDENT) {
        <app-student-auth></app-student-auth>
      }
      @case (AuthType.LECTURER) {
        <app-lecturer-auth></app-lecturer-auth>
      }
      @default {
        <nz-alert nzType="warning" nzMessage="Что-то пошло не так..."></nz-alert>
      }
    }
  </div>
</div>

<div class="auth-type-selector">
  <span nz-typography nzType="secondary" class="auth-type-selector__note">Другие способы аутентификации</span>
  <div class="auth-type-options">
    @if (selectedAuthType() !== AuthType.STUDENT) {
      <nz-form-item>
        <button nz-button nzType="text" (click)="setAuthType(AuthType.STUDENT)">
          <i nz-icon nzType="idcard" nzTheme="outline"></i>Войти как студент
        </button>
      </nz-form-item>
    }

    @if (selectedAuthType() !== AuthType.BASIC) {
      <nz-form-item>
        <button nz-button nzType="text" (click)="setAuthType(AuthType.BASIC)">
          <i nz-icon nzType="user" nzTheme="outline"></i>Базовая аутентификация
        </button>
      </nz-form-item>
    }

    @if (selectedAuthType() !== AuthType.LECTURER) {
      <nz-form-item>
        <button nz-button nzType="text" (click)="setAuthType(AuthType.LECTURER)">
          <i nz-icon nzType="solution" nzTheme="outline"></i>Войти как преподаватель
        </button>
      </nz-form-item>
    }
  </div>
</div>
